import { z } from "zod";

export const WorkflowStatusSchema = z.enum([
	"DRAFT",
	"PRD",
	"READY",
	"RUNNING",
	"STOPPED",
]);

export const WorkflowListItemSchema = z
	.object({
		id: z.string().cuid(),
		name: z.string(),
		description: z.string().nullable().optional(),
		status: WorkflowStatusSchema.optional(),
		createdAt: z.string().datetime().optional(),
		updatedAt: z.string().datetime().optional(),
	})
	.passthrough();

export const WorkflowSchema = z
	.object({
		id: z.string().cuid(),
		name: z.string(),
		description: z.string().nullable().optional(),
		status: WorkflowStatusSchema.optional(),
		prd: z.string().nullable().optional(),
		definition: z.any().optional(),
		createdAt: z.string().datetime().optional(),
		updatedAt: z.string().datetime().optional(),
	})
	.passthrough();

export const GetWorkflowsResponseSchema = z.object({
	workflows: z.array(WorkflowListItemSchema),
	total: z.number(),
	page: z.number(),
	limit: z.number(),
});

export const CreateWorkflowRequestSchema = z.object({
	name: z.string(),
	description: z.string().optional(),
});

export const UpdateWorkflowRequestSchema = z.object({
	name: z.string().optional(),
	description: z.string().optional(),
	status: WorkflowStatusSchema.optional(),
	prd: z.string().optional(),
	definition: z.any().optional(),
});

export const DeleteWorkflowResponseSchema = z.object({
	success: z.boolean(),
});

export type WorkflowStatus = z.infer<typeof WorkflowStatusSchema>;
export type WorkflowListItem = z.infer<typeof WorkflowListItemSchema>;
export type Workflow = z.infer<typeof WorkflowSchema>;
export type GetWorkflowsResponse = z.infer<typeof GetWorkflowsResponseSchema>;
export type CreateWorkflowRequest = z.infer<typeof CreateWorkflowRequestSchema>;
export type UpdateWorkflowRequest = z.infer<typeof UpdateWorkflowRequestSchema>;
export type DeleteWorkflowResponse = z.infer<typeof DeleteWorkflowResponseSchema>;
